module.exports = __webpack_public_path__ + "img/ring.c18c29d6.png";